module.exports = __webpack_public_path__ + "media/components/country-flag/static/bb-55cf5c7f9b6be54fbea679b56ba1bc39.svg";